import ModalGraficos from './ModalGraficos';

export default ModalGraficos;
